import { sortable, pageable, getQueryParamValue } from './utils.js'
import type { MirageServer, MockServer } from './server.js'

export function routes(server: MockServer) {
  server.get(
    '/clinic_staff_users',
    function (this: MirageServer, schema, request) {
      let collection = schema.where('user', {})

      // Apply filter[work_role] - supports both single value and array of values
      const workRoleParam = getQueryParamValue(
        request.queryParams?.['filter[work_role]'],
      )
      if (workRoleParam) {
        // Normalize to array - handle both single values and comma-separated arrays
        const workRoles = Array.isArray(workRoleParam)
          ? workRoleParam
          : workRoleParam.split(',').map((role) => role.trim())

        collection = collection.filter((user) =>
          workRoles.includes(user.attrs.work_role),
        )
      }

      // Apply search
      const search = getQueryParamValue(request.queryParams?.['filter[search]'])
      if (search) {
        collection = collection.filter((item) => {
          const firstAndLastName =
            `${item.attrs.first_name} ${item.attrs.last_name}`?.toLowerCase()
          return firstAndLastName.includes(search.toLowerCase())
        })
      }

      // Apply sorting and pagination
      const sorted = sortable(collection, request)
      const { data, meta } = pageable(sorted, request)

      return {
        ...this.serialize(data),
        meta: {
          pagination: meta,
        },
      }
    },
  )
}
